import React, { Dispatch, SetStateAction, useMemo } from 'react';
//components
import { Quantity } from './Quantity';
import { UnitPrice } from './UnitPrice';
import { Rentability } from './Rentability';
//interfaces
import { QuantityProps } from './Quantity/interface';
import { UnitPriceProps } from './UnitPrice/interface';
import { RentabilityProps } from './Rentability/interface';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
//utils
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
import { currencyOutputNumber } from 'utils/CurrencyOutput';
import { userSavedIsAutomatic } from 'pages/Quotes/Dashboard/utils';

type UnitPriceOmit = Omit<UnitPriceProps, 'formatedUnitPrice' | 'handleValueInput' | 'readOnly'>;

interface InputsProps extends RentabilityProps, UnitPriceOmit, QuantityProps {
  setIsAgreementPriceValue: Dispatch<SetStateAction<boolean>>;
  setUpdateUnitPrice: Dispatch<SetStateAction<boolean>>;
  blockedMinimumPrice: boolean;
  segmentComparison: boolean;
  minimumPrice: number;
  listCemed: boolean;
  item: any;
  tooltipText?: string;
}

const Inputs: React.FC<InputsProps> = (props) => {
  const {
    item,
    stock,
    readOnly,
    quantity,
    multiple,
    isEditing,
    unitPrice,
    listCemed,
    openTooltip,
    setQuantity,
    minimumPrice,
    setUnitPrice,
    setOpenTooltip,
    setRentability,
    updatedMinPrice,
    unitPriceMessage,
    minimumPriceLock,
    showMinPriceModal,
    segmentComparison,
    setUpdateUnitPrice,
    unitPriceValidator,
    setMinimumPriceLock,
    blockedMinimumPrice,
    setShowMinPriceModal,
    validateConversionQt,
    handleKeepFactoryPrice,
    minProfitabilityMessage,
    setIsAgreementPriceValue,
    convertedRentabilityValue,
    tooltipText
  } = props;

  const { quoteDetail } = useDetailsQuoteContext();

  const handleUnitPriceCurrencyFormat = (unitPriceValue: number) => {
    return currencyOutputNumber(unitPriceValue);
  };

  const valueUnitPrice: string = useMemo(() => {
    if (isEditing) {
      return handleUnitPriceCurrencyFormat(unitPrice);
    } else {
      return handleUnitPriceCurrencyFormat(item.salePrice);
    }
  }, [isEditing, item, unitPrice]);

  const rentability: string = useMemo(() => {
    if (isEditing) {
      return convertedRentabilityValue;
    } else {
      return Number(item.rentabilitySaved?.toString().replace(",", ".")).toLocaleString(
        "pt-BR",
        { maximumFractionDigits: 4 }
      );
    }
  }, [isEditing, item, unitPrice]);

  return (
    <>
      <Rentability
        stock={stock}
        readOnly={readOnly}
        isEditing={isEditing}
        setRentability={setRentability}
        setUpdateUnitPrice={setUpdateUnitPrice}
        convertedRentabilityValue={rentability}
        handleKeepFactoryPrice={handleKeepFactoryPrice}
        minProfitabilityMessage={minProfitabilityMessage}
        setIsAgreementPriceValue={setIsAgreementPriceValue}
        tooltipText={tooltipText}
      />

      <UnitPrice
        item={item}
        readOnly={readOnly}
        isEditing={isEditing}
        unitPrice={unitPrice}
        listCemed={listCemed}
        openTooltip={openTooltip}
        minimumPrice={minimumPrice}
        setUnitPrice={setUnitPrice}
        setOpenTooltip={setOpenTooltip}
        setRentability={setRentability}
        updatedMinPrice={updatedMinPrice}
        formatedUnitPrice={valueUnitPrice}
        stock={{
          ...stock,
          factoryPrice: stock?.factoryPrice,
          minimumPrice: stock?.minimumPrice,
        }}
        unitPriceMessage={unitPriceMessage}
        minimumPriceLock={minimumPriceLock}
        segmentComparison={segmentComparison}
        showMinPriceModal={showMinPriceModal}
        unitPriceValidator={unitPriceValidator}
        setMinimumPriceLock={setMinimumPriceLock}
        blockedMinimumPrice={blockedMinimumPrice}
        setShowMinPriceModal={setShowMinPriceModal}
        handleKeepFactoryPrice={handleKeepFactoryPrice}
        setIsAgreementPriceValue={setIsAgreementPriceValue}
        tooltipText={tooltipText}
      />

      <Quantity
        quantity={quantity}
        multiple={multiple}
        readOnly={readOnly}
        unitPrice={unitPrice}
        isEditing={isEditing}
        openTooltip={openTooltip}
        setQuantity={setQuantity}
        validateConversionQt={validateConversionQt}
        tooltipText={tooltipText}
      />
    </>
  );
};

export default Inputs;